export enum CenterAction {
    Cpr = 1,
    Pairs = 2,
    Login = 3,
    Edit = 4,
    Contacts = 5,
    ActionCenter = 6,
    AccountPlan = 7
}